import {BarChartOnly} from '@/_metronic/partials/content/chart/BarChartOnly'
import {memo, useMemo} from 'react'
import {useQueryRequest} from '../../core/QueryRequestProvider'
import { useGetActiveEmployee } from '../../core/_query'

const MemoizedBarChart = memo(BarChartOnly)

const TrendAnalysisRevenueBar = () => {
  const {state} = useQueryRequest()
  const {data: revenueData, isLoading} = useGetActiveEmployee({...state, set_is_job_therapist: true})
  const months: string[] = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  const revenue = useMemo(() => {
    return revenueData?.response?.data
  }, [revenueData])

  return (
    <>
      <div className='card area-wib shadow-wit'>
        <RevenueHeader />
        <MemoizedBarChart
          className='area-wib shadow-wit'
          color='primary'
          secondColor='gray-500'
          title='Employee Active vs Non Active'
          tableView={false}
          isCurrency={false}
          data={revenue?.map((x) => ({
            month: x.months,
            active_employee_count: x.active_employee_count,
            inactive_employee_count: x.inactive_employee_count,
          }))}
          headers={['Bulan', 'Active Employee', 'Non Active Employee']}
          formatCurrency={['active_employee_count', 'inactive_employee_count']}
          series={[
            {
              name: 'Active Employee',
              data: revenue?.map((item) => item.active_employee_count),
            },
            {
              name: 'Non Active Employee',
              data: revenue?.map((item) => item.inactive_employee_count),
            },
          ]}
          categories={revenue?.map((item) =>
            months[(item.months ?? 1) - 1]
          )}
          //   total={data?.summary_trend?.sales}
          layout='horizontal'
          isLoading={isLoading}
        />
      </div>
    </>
  )
}

const RevenueHeader = () => {
  const {state} = useQueryRequest()
  // const {data: summaryTrendData, isLoading: summaryTrendLoading} = useGetSummaryTrend(state)

  // const summaryTrend = useMemo(() => {
  //   return summaryTrendData?.response?.data
  // }, [summaryTrendData])

  return (
    <div className='card-header border-0 pt-5'>
      <h3 className='card-title align-items-start flex-column'>
        <span className='card-label fw-bold fs-3 mb-1'>Employee Active vs Non Active</span>
      </h3>
    </div>
  )
}

export {TrendAnalysisRevenueBar}
